import { useState } from "react";

import DownArrowIcon from "assets/icons/downArrow.svg?react";

import styles from "./DashboardWidgetItem.module.css";

const DashboardWidgetItem = ({ item, variant }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const dateFormatOptions = {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
    };
    const dateFormatOptionsNotice = {
        day: "2-digit",
        month: "long",
        year: "numeric",
    };
    const timeFormatOptions = {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    };

    return (
        <li
            className={`${styles.dashboardWidgetItem} ${styles[variant]}`}
            onClick={() => setIsExpanded((prev) => !prev)}
        >
            <span className={styles.dashboardWidgetItemTitle}>
                {variant === "toDoList" || variant === "noticeBoard"
                    ? item.title
                    : item.name}
            </span>

            {isExpanded && item.content && (
                <p className={styles.dashboardWidgetItemContent}>
                    {item.content}
                </p>
            )}

            {variant === "toDoList" && (
                <>
                    <span
                        className={`${styles.dashboardWidgetItemContext} ${styles[item.context.split(" ")[0].toLowerCase()]}`}
                    >
                        {item.context}
                    </span>
                    <span className={styles.dashboardWidgetItemDate}>
                        Due:{" "}
                        {new Date(item.date).toLocaleDateString(
                            "en-US",
                            dateFormatOptions,
                        )}{" "}
                        at{" "}
                        {new Date(item.date).toLocaleTimeString(
                            "en-US",
                            timeFormatOptions,
                        )}
                    </span>
                </>
            )}

            {variant === "courses" && (
                <>
                    <span className={styles.dashboardWidgetItemTeachers}>
                        {item.teachers.length < 1
                            ? "No teachers assigned"
                            : item.teachers
                                  .map((teacher) => teacher.name)
                                  .join(", ")}
                    </span>
                </>
            )}

            {variant === "noticeBoard" && (
                <>
                    <span className={styles.dashboardWidgetItemDate}>
                        {new Date(item.date).toLocaleDateString(
                            "en-US",
                            dateFormatOptionsNotice,
                        )}
                    </span>
                    <DownArrowIcon
                        className={`${styles.dashboardWidgetItemIcon} ${isExpanded ? styles.expanded : ""}`}
                    />
                </>
            )}

            {variant !== "noticeBoard" && (
                <a
                    className={`${styles.dashboardWidgetItemAction} ${variant === "courses" ? styles.default : ""}`}
                    href={variant === "courses" ? item.link : item.view}
                    target="_blank"
                >
                    View
                </a>
            )}
        </li>
    );
};

export default DashboardWidgetItem;
